import {COMP_ARRAYS, COMP_FIELDS, CompFieldValue} from '@/constants/comp';

type PRV_COMP_FIELDS = {[K in keyof typeof COMP_FIELDS]: `PRV_${(typeof COMP_FIELDS)[K]}`};
type PRV_COMP_ARRAYS = {[K in keyof typeof COMP_ARRAYS]: `PRV_${(typeof COMP_ARRAYS)[K]}`};

export const PRV_COMP_FIELDS: PRV_COMP_FIELDS = Object.fromEntries(
  Object.entries(COMP_FIELDS).map(([key, value]) => [key, `PRV_${value}`]),
) as PRV_COMP_FIELDS;

export const PRV_COMP_ARRAYS: PRV_COMP_ARRAYS = Object.fromEntries(
  Object.entries(COMP_ARRAYS).map(([key, value]) => [key, `PRV_${value}`]),
) as PRV_COMP_ARRAYS;

export const ALL_PRV_COMP_ARRAYS = Object.values(PRV_COMP_ARRAYS);

export type PRV_COMP_ARRAY = (typeof ALL_PRV_COMP_ARRAYS)[number];

export type AccountFieldsPrefix = 'COMP' | 'PRV_COMP';

export const withPrefix = (
  compKeyField: CompFieldValue,
  prefix: AccountFieldsPrefix,
): CompFieldValue | `PRV_${CompFieldValue}` => (prefix === 'PRV_COMP' ? `PRV_${compKeyField}` : compKeyField);
